.container {
  display: flex;
  align-items: center;
}

.checkbox {
  -webkit-appearance: none;
  appearance: none;
  background: none;
  height: 16px;
  width: 16px;
  display: inline-block;
  vertical-align: text-bottom;
  position: relative;
  border-radius: 100%;
  margin: 0;
  padding: 10px;
}

.checkbox:focus {
  outline: 2px solid;
  outline-offset: 2px;
}

.checkbox::before {
  content: "";
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  top: 0;
  background-image: url("data:image/svg+xml,%3Csvg fill='none' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 10'%3E%3Cpath d='m2 2 6 6 6-6' stroke='%23201F23' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-size: 16px 10px;
  background-repeat: no-repeat;
  background-position: center;
  transform: rotate(0);
  transition: transform 0.3s;
  cursor: pointer;
}

.checkbox:checked::before {
  transform: rotate(-180deg);
}

@media (prefers-reduced-motion) {
  .checkbox:before {
    transition: none;
  }
}

.label {
  color: #201f23;
  font-weight: 500;
  cursor: pointer;
  padding-left: 6px;
  font-size: 14px;
  font-weight: 600;
}
